

















































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    class EditOrderModel {
        id?: number;
        warehouseInfoId: number;
        returnTime?: Date;
        whetherHandle?: boolean;
        userCode: string;
        shipment?: string;
        reMark?: string;
        orderNumber: string;
    }
    @Component
    export default class EditFreightModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        EditModel: EditOrderModel = new EditOrderModel();
        addLoding = false;
        warehouseCityId: number = 0;
        warehouseCityList: Array<warehouseCity> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        returnsTimeVal: string = "";
        async edit() {
          
                    this.addLoding = true;
                    await this.$store.dispatch({
                        type: 'orderreturn/editOrderReturn',
                        data: this.EditModel
                    }).finally(() => {
                        this.addLoding = false;
                    });
                    (this.$refs.editForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
           
        }
        created() {
            this.getCity();
        }
        cancel() {
            (this.$refs.editForm as any).resetFields();
            this.$emit('input', false);
        }
        async changeWarehouseCity(val: number) {
            this.warehouseInfoList = await this.$store.dispatch({
                type: 'warehouseInfo/get',
                data: { CityId: val }
            });
            if (this.warehouseInfoList.length == 1) {
                this.EditModel.warehouseInfoId = this.warehouseInfoList[0].id;
            }
        }
        async getCity() {
            this.warehouseCityList = await this.$store.dispatch({
                type: 'warehouseCity/get',
                data: {}
            });
            if (this.warehouseCityList.length > 0) {
                this.warehouseCityId = this.warehouseCityList[0].id;
                this.changeWarehouseCity(this.warehouseCityId);
            }
        }

        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                (this.$refs.editForm as any).resetFields();
                var data = this.$store.state.orderreturn.orderReturnInfo;
                this.EditModel.id = data.id;
                this.EditModel.warehouseInfoId = data.warehouseInfoId;
                this.EditModel.orderNumber = data.orderNumber;
                this.EditModel.reMark = data.reMark;
                this.EditModel.returnTime = data.returnTime;
                this.EditModel.shipment = data.shipment;
                this.EditModel.userCode = data.userCode;
                this.EditModel.whetherHandle = data.whetherHandle
            }
        }

    }
